import { Component } from '@angular/core';

@Component({
  selector: 'fb-expansion-panel-header',
  templateUrl: './expansion-panel-header.html',
  styleUrl: './expansion-panel-header.scss',
})
export class ExpansionPanelHeader {}
